import { IUserRole } from 'types/users';

export type IPermissionRule =
  | 'applicants:message'
  | 'applicants:view'
  | 'application:edit'
  | 'application:edit-tasklist'
  | 'application:create-message-template'
  | 'application:grant-access'
  | 'application:hire'
  | 'application:retract'
  | 'application:add'
  | 'application:use-apps'
  | 'application:use-application-selection'
  | 'application:edit-files'
  | 'applicants:use-bulk-actions'
  | 'application:send-admanager'
  | 'application:bulk-edit-h3core'
  | 'application:bulk-send-admanager'
  | 'application:bulk-send-hireflix'
  | 'application:bulk-send-onboarding'
  | 'application:bulk-create-journeys'
  | 'application:add-journeys'
  | 'application:move'
  | 'application:use-messages'
  | 'application:onboarding'
  | 'application:reject'
  | 'application:revoke-access'
  | 'application:view-options'
  | 'application:assign'
  | 'application:edit-stages'
  | 'company:apps'
  | 'company:view-signet'
  | 'company:view-taktikal'
  | 'company:edit-templates'
  | 'company:details-settings'
  | 'company:view-settings'
  | 'company:view-career-settings'
  | 'company:view-admin-settings'
  | 'company:view-integrations-settings'
  | 'company:view-templates'
  | 'departments:add'
  | 'departments:edit'
  | 'departments:delete'
  | 'departments:add-user'
  | 'locations:view'
  | 'locations:add'
  | 'locations:edit'
  | 'locations:delete'
  | 'joblabels:view'
  | 'joblabels:add'
  | 'joblabels:edit'
  | 'joblabels:delete'
  | 'jobs:view'
  | 'jobs:view-apps'
  | 'job:access'
  | 'job:access:manage'
  | 'job:add-recruiter'
  | 'job:apps'
  | 'job:create'
  | 'job:delete'
  | 'job:export'
  | 'job:duplicate'
  | 'job:options'
  | 'job:promote'
  | 'job:rename'
  | 'job:statistics'
  | 'job:view'
  | 'job:view-integrations'
  | 'job:view-team'
  | 'job:ordering'
  | 'jobboards:manage'
  | 'api:view'
  | 'notifications:view'
  | 'sharing:view'
  | 'slack:auth'
  | 'team:create-user'
  | 'team:edit-user'
  | 'team:view'
  | 'user:app:create'
  | 'worktypes:view'
  | 'worktypes:add'
  | 'worktypes:edit'
  | 'worktypes:delete';

export const rules: Record<IPermissionRule, Array<IUserRole>> = {
  'applicants:message': ['superadmin', 'admin', 'recruiter'],
  'applicants:view': ['superadmin', 'admin', 'recruiter', 'limited'],
  'application:use-messages': ['superadmin', 'admin', 'recruiter'],
  'application:create-message-template': ['admin', 'superadmin'],
  'application:use-application-selection': ['superadmin', 'admin', 'recruiter'],
  'application:add': ['superadmin', 'admin', 'recruiter'],
  'application:send-admanager': ['superadmin', 'admin', 'recruiter'],
  'application:bulk-edit-h3core': ['superadmin', 'admin', 'recruiter'],
  'application:bulk-send-admanager': ['superadmin', 'admin', 'recruiter'],
  'application:bulk-send-hireflix': ['superadmin', 'admin', 'recruiter'],
  'application:bulk-create-journeys': ['superadmin', 'admin', 'recruiter'],
  'application:add-journeys': ['superadmin', 'admin', 'recruiter'],
  'application:edit-files': ['superadmin', 'admin', 'recruiter'],
  'application:bulk-send-onboarding': ['superadmin', 'admin', 'recruiter'],
  'applicants:use-bulk-actions': ['superadmin', 'admin', 'recruiter'],
  'application:use-apps': ['superadmin', 'admin', 'recruiter'],
  'application:edit': ['superadmin', 'admin', 'recruiter'],
  'application:edit-stages': ['superadmin', 'admin', 'recruiter'],
  'application:assign': ['superadmin', 'admin', 'recruiter'],
  'application:edit-tasklist': ['superadmin', 'admin', 'recruiter', 'limited'],
  'application:grant-access': ['superadmin', 'admin', 'recruiter'],
  'application:hire': ['superadmin', 'admin', 'recruiter'],
  'application:retract': ['superadmin', 'admin', 'recruiter'],
  'application:move': ['superadmin', 'admin', 'recruiter'],
  'application:onboarding': ['superadmin', 'admin', 'recruiter', 'limited'],
  'application:reject': ['superadmin', 'admin', 'recruiter'],
  'application:revoke-access': ['superadmin', 'admin'],
  'application:view-options': ['superadmin', 'admin', 'recruiter', 'limited'],
  'company:apps': ['superadmin', 'admin'],
  'company:view-signet': ['superadmin'],
  'company:view-taktikal': ['superadmin'],
  'company:edit-templates': ['superadmin', 'admin'],
  'company:view-career-settings': ['superadmin'],
  'company:view-admin-settings': ['superadmin', 'admin'],
  'company:view-integrations-settings': ['superadmin'],
  'company:details-settings': ['superadmin'],
  'company:view-settings': ['superadmin', 'admin'],
  'company:view-templates': ['superadmin', 'admin'],
  'departments:add': ['superadmin'],
  'departments:edit': ['superadmin'],
  'departments:delete': ['superadmin'],
  'departments:add-user': ['superadmin', 'admin'],
  'locations:view': ['superadmin', 'admin'],
  'locations:add': ['superadmin'],
  'locations:edit': ['superadmin'],
  'locations:delete': ['superadmin'],
  'joblabels:view': ['superadmin', 'admin'],
  'joblabels:add': ['superadmin'],
  'joblabels:edit': ['superadmin'],
  'joblabels:delete': ['superadmin'],
  'jobs:view': ['superadmin', 'admin', 'recruiter', 'limited'],
  'jobs:view-apps': ['superadmin', 'admin'],
  'job:access': ['superadmin', 'admin', 'recruiter'],
  'job:access:manage': ['superadmin', 'admin'],
  'job:add-recruiter': ['superadmin', 'admin'],
  'job:apps': ['superadmin', 'admin', 'recruiter'],
  'job:create': ['superadmin', 'admin', 'recruiter'],
  'job:delete': ['superadmin', 'admin'],
  'job:export': ['superadmin', 'admin', 'recruiter'],
  'job:duplicate': ['superadmin', 'admin', 'recruiter'],
  'job:options': ['superadmin', 'admin', 'recruiter'],
  'job:promote': ['superadmin', 'admin', 'recruiter'],
  'job:rename': ['superadmin', 'admin', 'recruiter'],
  'job:statistics': ['superadmin', 'admin', 'recruiter'],
  'job:view': ['superadmin', 'admin', 'recruiter', 'limited'],
  'job:view-integrations': ['superadmin', 'admin', 'recruiter', 'limited'],
  'job:view-team': ['superadmin', 'admin', 'recruiter', 'limited'],
  'job:ordering': ['superadmin'],
  'api:view': ['superadmin', 'admin'],
  'jobboards:manage': ['superadmin', 'admin'],
  'notifications:view': ['superadmin', 'admin', 'recruiter', 'limited'],
  'sharing:view': ['superadmin', 'admin', 'recruiter', 'limited', 'user'],
  'slack:auth': ['superadmin', 'admin', 'recruiter', 'limited', 'user'],
  'team:create-user': ['superadmin', 'admin'],
  'team:edit-user': ['superadmin', 'admin'],
  'team:view': ['superadmin', 'admin', 'recruiter'],
  'user:app:create': ['superadmin', 'admin'],
  'worktypes:view': ['superadmin'],
  'worktypes:add': ['superadmin'],
  'worktypes:edit': ['superadmin'],
  'worktypes:delete': ['superadmin'],
};
